import { render, staticRenderFns } from "./Form.Fornecedor.vue?vue&type=template&id=656fa13d"
import script from "./Form.Fornecedor.vue?vue&type=script&lang=js"
export * from "./Form.Fornecedor.vue?vue&type=script&lang=js"
import style0 from "./Form.Fornecedor.vue?vue&type=style&index=0&id=656fa13d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports